module.exports = __webpack_public_path__ + "img/Oil Filter.11908b24.jpg";